// src/components/CameraPanel.js
import React, { useEffect, useState, useRef } from "react"
import { db } from "./firebase"
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot
} from "firebase/firestore"

const ALERT_COLLS = [
  "iot-bushfire-alerts",
  "iot-poaching-alerts",
  "iot-deforestation-alerts",
]

export default function CameraPanel({ zone }) {
  const STREAM_URL = `http://172.20.10.4:8000/stream`

  const [snapshotUrl, setSnapshotUrl] = useState(null)
  const [streamUp, setStreamUp]       = useState(true)
  const retryTimer = useRef(null)

  // 1) Listen for the *latest* snapshot from any of your three alert collections
  useEffect(() => {
    const unsub = ALERT_COLLS.map((coll) => {
      const q = query(
        collection(db, coll),
        where("zone", "==", `Zone-${zone}`),
        where("snapshot", "!=", null),
        orderBy("timestamp", "desc")
      )
      return onSnapshot(q, (snap) => {
        if (snap.docs.length === 0) return
        // take the very first doc with a snapshot
        const url = snap.docs[0].data().snapshot
        setSnapshotUrl(url)
      })
    })
    return () => unsub.forEach((u) => u())
  }, [zone])

  // 2) Ping the stream every 5s to see if it’s up again after failure
  useEffect(() => {
    return () => clearTimeout(retryTimer.current)
  }, [])

  function handleStreamError() {
    setStreamUp(false)
    // after 5s, try again
    retryTimer.current = setTimeout(() => {
      setStreamUp(true)
    }, 5000)
  }

  return (
    <div className="bg-white p-5 rounded-lg shadow-md w-full min-h-[300px] flex flex-col items-center justify-center">
      <h3 className="text-xl font-semibold mb-4 text-center">
        Live Camera Feed — Zone {zone}
      </h3>

      {/* 1) Try your Pi’s MJPEG stream */}
      {streamUp && (
        <img
          src={STREAM_URL}
          alt={`Live stream Zone ${zone}`}
          className="rounded-md border max-h-64 w-full object-contain"
          onError={handleStreamError}
          onLoad={() => setStreamUp(true)}
        />
      )}

      {/* 2) If the stream is down, show the latest snapshot */}
      {!streamUp && snapshotUrl && (
        <img
          src={snapshotUrl}
          alt={`Last snapshot Zone ${zone}`}
          className="rounded-md border max-h-64 w-full object-contain"
        />
      )}

      {/* 3) If *neither* is available */}
      {!streamUp && !snapshotUrl && (
        <div className="flex flex-col items-center justify-center w-full h-40">
          <span className="text-4xl mb-2">📷</span>
          <p className="text-gray-500">Camera offline & no snapshots yet.</p>
        </div>
      )}
    </div>
  )
}
